const authURL = s => `/api/auth/${s}`;
const createResponse = (success = false, errors = {}) => ({ success, errors });

export const authAPI = {
  register: {
    async createAccount(formParams) {
      const apiResponse = await axios.post(authURL('register/create-account'), formParams).catch(r => r.response);

      if (apiResponse.status === 422) {
        return createResponse(false, apiResponse.data.errors);
      }

      return createResponse(true);
    },
    async createProfile(formParams) {
      const params = {
        ...formParams,
        website: formParams.website && !formParams.website.includes('https://') ?
          `https://${formParams.website}` :
          formParams.website,
       }

      const apiResponse = await axios.post(authURL('register/create-profile'), params).catch(r => r.response);

      if (apiResponse.status === 422) {
        return createResponse(false, apiResponse.data.errors);
      }

      return createResponse(true);
    },
    async jediPledgeAgreement(formParams) {
      const apiResponse = await axios.post(authURL('register/jedi-pledge-agreement'), formParams).catch(r => r.response);

      if (apiResponse.status === 422) {
        return createResponse(false, apiResponse.data.errors);
      }

      if (apiResponse.status > 300 || apiResponse.status < 199) {
        return createResponse(false);
      }

      return createResponse(true);
    }
  }
}